import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { blogNavigatePath } from "../../Utils/detailsNavigatePath";

// Theme config
const darkTheme = {
  green: "#12C895",
  greenLow: "rgba(18, 200, 149, 0.05)",
  glassBg: "rgba(20, 26, 36, 0.8)",
  borderRaw: "rgba(255, 255, 255, 0.06)",
  textWhite: "#F8FAFC",
  textMuted: "#94A3B8",
};

export default function BlogCart({ blog }) {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => navigate(blogNavigatePath(blog))}
      sx={{
        width: "100%",
        aspectRatio: "1 / 1",
        bgcolor: darkTheme?.glassBg,
        border: `1px solid ${darkTheme?.borderRaw}`,
        borderRadius: "16px",
        cursor: "pointer",
        overflow: "hidden",
        transition: "all 0.4s ease",
        position: "relative",
        zIndex: "10",
        "&:hover": {
          borderColor: darkTheme?.green,
          boxShadow: `inset 0 0 40px ${darkTheme?.greenLow}, 0 10px 30px rgba(0,0,0,0.5)`,
          "& img": {
            transform: "scale(1.05)",
          },
          "& .readBtn": {
            bgcolor: darkTheme?.green,
            color: "#000",
            borderColor: darkTheme?.green,
          },
          "& .title-bar": {
            borderColor: darkTheme?.green,
            color: darkTheme?.green,
          },
        },
      }}
    >
      {/* Background Image */}
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          zIndex: "-2",
          overflow: "hidden",
        }}
      >
        <img
          src={`${import.meta.env?.VITE_URL}${blog?.header_image?.file_name}`}
          alt={blog?.header_image?.alt || blog?.title}
          loading="lazy"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transition: "transform 0.5s ease",
          }}
        />
      </Box>

      {/* Glass Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to top, rgba(10, 15, 25, 0.95) 0%, rgba(10, 15, 25, 0.2) 100%)",
          zIndex: "-1",
        }}
      />

      {/* Content */}
      <Stack
        spacing={3}
        sx={{
          p: { xs: 2, xl: 3 },
          direction: "rtl",
          width: "100%",
          height: "100%",
          justifyContent: "flex-end",
          boxSizing: "border-box",
        }}
      >
        <Typography
          className="title-bar"
          sx={{
            color: darkTheme?.textWhite,
            fontWeight: 700,
            fontSize: { xs: "1rem", md: "1.1rem" },
            lineHeight: 1.7,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            borderRight: "4px solid",
            borderColor: darkTheme?.borderRaw,
            pr: "12px",
            transition: ".3s",
          }}
        >
          {blog?.title}
        </Typography>

        <Button
          fullWidth
          className="readBtn"
          variant="outlined"
          sx={{
            borderRadius: "8px",
            borderColor: darkTheme?.borderRaw,
            color: darkTheme?.textMuted,
            px: 3,
            py: 1.2,
            transition: ".3s",
            mt: "auto",
            fontSize: ".8rem",
            fontWeight: 600,
            backdropFilter: "blur(10px)",
            fontFamily: "monospace",
          }}
        >
          VIEW_ARTICLE
        </Button>
      </Stack>
    </Box>
  );
}
